import React from "react";
import styled from "styled-components";
import TableCell from "../TableCell";

export const Cell: React.FC<{
  children: string;
  highlight?: string;
  showMark?: boolean;
  bold?: string;
  appearance?: "modern" | "legacy";
}> = ({ children: text, highlight = "", showMark, bold, appearance = "modern" }) => {
  if (!highlight.trim()) {
    return (
      <TableCell $appearance={appearance}>
        {bold && <span className="bold">{bold}</span>}
        <span>{text}</span>
      </TableCell>
    );
  }

  const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(escapedHighlight, "ig");
  const fragments: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      fragments.push(<span key={`${match.index}-text`}>{text.slice(lastIndex, match.index)}</span>);
    }
    fragments.push(<Mark key={`${match.index}-mark`}>{match[0]}</Mark>);
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    fragments.push(<span key="tail">{text.slice(lastIndex)}</span>);
  }

  return (
    <TableCell $appearance={appearance}>
      <span>{showMark ? fragments : text}</span>
    </TableCell>
  );
};

const Mark = styled.mark`
  background-color: inherit;
  color: red;
`;
